import {
  getAuthToken,
  removeAuthToken,
  removeShopId,
  removeRelationType,
} from '@/persistence/cookie';
import { request } from 'umi';

export const logout = async (): Promise<void> => {
  const authToken = getAuthToken();

  removeAuthToken();
  removeRelationType();
  removeShopId();

  if (authToken) {
    return request('/logout', {
      method: 'POST',
      skipErrorHandler: true,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(() => undefined)
      .catch(() => undefined);
  }
};
